import { Agencies } from "./agencies";

export class Produit {
  id?: number;
  name?: string;                // Français
  nomarab?: string;             // Arabe
  nomanglais?: string;          // ✅ NEW: Anglais
  description?: string;         // Français
  descriptionAnglais?: string;  // ✅ NEW: Description en anglais
  agencyName?: string | Agencies[];
  prix?: string | number;
  imageUrl?: string;
  status?: string;
  categorie?: string;
  categoryList?: string[];
  promoTitle?: string;
  promoImg?: string;
  videoUrlProduit?: string;
  nomCommercial?: string;
  numCommercial?: string;
  emailCommercial?: string;
  NameAgence?: any;
  image_url?: any;
}